import { MapPin, Phone, EnvelopeSimple } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer className="bg-[#3F4E4F] text-stone-200 mt-24" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="font-serif text-3xl text-white">Luxe Aroma Scents</div>
          <div className="label-caps text-[#C0A062] mb-4">luxearomascents.com</div>
          <p className="text-sm text-stone-300 max-w-xs leading-relaxed">
            Fragancias, velas, joyería y decoración cuidadosamente seleccionadas para transformar tu hogar en un santuario.
          </p>
        </div>
        <div>
          <h4 className="label-caps text-white mb-4">Tienda</h4>
          <ul className="space-y-2 text-sm text-stone-300">
            <li>Fragancias</li>
            <li>Hogar</li>
            <li>Decoración</li>
            <li>Joyería</li>
          </ul>
        </div>
        <div>
          <h4 className="label-caps text-white mb-4">Contacto</h4>
          <ul className="space-y-3 text-sm text-stone-300">
            <li className="flex items-start gap-3" data-testid="footer-address">
              <MapPin size={18} className="text-[#C0A062] shrink-0 mt-0.5" />
              <span>14655 SW 56 St, Local #10<br />Miami, FL 33175<br /><span className="text-stone-400">(dentro de Sedano's Supermarket)</span></span>
            </li>
            <li className="flex items-center gap-3" data-testid="footer-phone">
              <Phone size={18} className="text-[#C0A062] shrink-0" />
              <a href="tel:+17863086973" className="hover:text-white">(786) 308-6973</a>
            </li>
            <li className="flex items-center gap-3" data-testid="footer-email">
              <EnvelopeSimple size={18} className="text-[#C0A062] shrink-0" />
              <a href="mailto:luxearomascents@yahoo.com" className="hover:text-white break-all">luxearomascents@yahoo.com</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-stone-400">
        © {new Date().getFullYear()} Luxe Aroma Scents Inc. Todos los derechos reservados.
      </div>
    </footer>
  );
}
